<template>
  <div class="header">
    <!-- 左侧logo -->
    <div class="logo">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
           viewBox="0 0 66 66" enable-background="new 0 0 66 66" xml:space="preserve">
                <g><path d="M29.4,18.2c-0.6,0-1.1-0.5-1.1-1.1c0-0.3,0.1-0.6,0.3-0.8c-0.2-0.1-0.5-0.1-0.7-0.1c-1.4,0-2.5,1.1-2.5,2.5   c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5c0-0.3-0.1-0.6-0.2-0.9C30,18.1,29.7,18.2,29.4,18.2z M27.2,20   c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6C27.8,19.7,27.5,20,27.2,20z"></path>
                  <path
                      d="M40.5,20.4c-0.5,0-0.9-0.4-0.9-0.9c0-0.3,0.1-0.5,0.3-0.6c-0.2-0.1-0.4-0.1-0.6-0.1c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2   c1.1,0,2-0.9,2-2c0-0.2-0.1-0.5-0.1-0.7C41,20.3,40.8,20.4,40.5,20.4z M38.7,21.9c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5   c0.3,0,0.5,0.2,0.5,0.5C39.3,21.6,39,21.9,38.7,21.9z"></path>
                  <g><path d="M57.5,52c6.7-7.6,2.8-21.6-4.5-25.5c10.5-13.8,1.6-27.5-8.5-25.1c-3.2,0.7-5.3,3.2-5.6,5.7c-0.4,3.4,2.5,5.8,5.1,5.1    c1.5-0.4,2.4-1.8,2.2-3.1c-0.2-1.5-1.8-2.3-3-1.6c-0.6,0.4-0.6,0.8-0.5,0.8c0.1,0.1,0.3-0.2,0.7-0.4c0.9-0.4,1.9,0.2,2,1.3    c0.1,0.9-0.8,1.7-1.6,1.8c-1.6,0.3-3.3-1.4-2.7-3.5c1.3-4.5,10.3-3.6,9.9,3.9c-0.1,3.2-2.1,5.6-4.8,7.5c-0.7-0.4-1.4-0.7-2.2-1    c-2-4.4-6.4-6.5-9.3-3.5C31.6,6.7,23,9.7,21.3,18.3c-0.8,0.4-1.5,0.7-2.1,1.2c-2.6-1.2-4.7-2.9-5.3-5.7c-0.7-3.3,1.2-6,4-6.4    c1.4-0.2,3.1,0.4,3.8,1.7c0.8,1.7-0.3,3.3-1.7,3.3c-0.8,0-1.6-0.5-1.6-1.3c-0.1-0.9,0.7-1.6,1.5-1.3c0.4,0.1,0.6,0.3,0.7,0.3    c0.1,0,0-0.4-0.6-0.6c-1.1-0.4-2.3,0.4-2.3,1.8c0,1.1,1,2.1,2.3,2.3c2.3,0.2,4.3-2.1,3.5-5c-1.8-6.4-14.2-5.3-15,5.4    c-0.3,3.6,1.2,8.1,5.2,12.2c-4.3,2-7.3,7.6-8.2,12.3c-0.1,0.2-0.5,2.8-0.3,5.1C5.5,47,7.2,50.4,8.6,52c-1.7,1.2-2.5,5.2-0.7,5.6    c2.1,0.4-1.4-2.7,1.8-4.4c1.1,1.2,0.6,2.6,0.5,3.2C10.2,58,12,58,12.4,56.6c0.2-1-0.3-2.8-1.8-3.8c1.9-0.8,3.3,0.5,2.9,1.7    c-0.7,2.2,1.2,1.7,1.3,0.3c0.2-2.7-2.3-3.9-4.5-3.5c-0.1-1.2-0.2-2.3,0-4c0,0,0,0,0-0.1c0.1-1.3,0.6-2.9,1.2-4.4l0,0    c0.6-1.3,1.3-2.4,2.3-3.4c0.8,3.8,2.2,7.1,3.9,9.9c-0.2,1.5-0.1,3.2,0.5,5.3c1.5,5.3,2.7,7.8,3.1,8.6c-1.2-2-6-4.1-8,1.9h10.1    c0.7,0,1.2-0.6,1.2-1.2c-0.1-1.3,0-3.2,0.6-4.8c0.3-0.8,1-1.4,1.7-1.9c1.9,0.8,4.1,1.2,6.3,1.2c2.3,0,4.5-0.3,6.5-1.1    c0.7,0.5,1.3,1.1,1.6,1.8c0.6,1.6,0.7,3.5,0.6,4.8c0,0.7,0.5,1.2,1.2,1.2h10.1c-2-6-6.8-3.9-8-1.9c0.4-0.8,1.5-3.3,3.1-8.6    c0.6-2,0.7-3.7,0.5-5.2c1.7-2.7,3-5.8,3.8-9.5c0.7,0.9,1.3,1.8,1.8,2.9v0c1.9,4,1.2,8,1.2,8.5c-2.2-0.4-4.7,0.8-4.5,3.5    c0.1,1.4,1.9,1.9,1.3-0.3c-0.4-1.2,1.1-2.5,2.9-1.7c-1.5,1-2,2.8-1.8,3.8c0.3,1.4,2.1,1.4,2.1-0.2c0-0.7-0.6-2,0.5-3.2    c3.2,1.7-0.3,4.8,1.9,4.4C60,57.1,59.1,53.1,57.5,52z M39.8,16c2.2,0,4,2.1,4,4.7c0,2.6-1.8,4.7-4,4.7c-2.2,0-4-2.1-4-4.7    C35.8,18.1,37.6,16,39.8,16z M27.3,12.5c2.9,0,5.2,2.8,5.2,6.2c0,3.4-2.3,6.2-5.2,6.2c-2.9,0-5.2-2.8-5.2-6.2    C22.1,15.2,24.4,12.5,27.3,12.5z M46.8,40.8c-3,4.2-8,6.7-13.5,6.7c0,0,0,0,0,0c-5.5,0-10.5-2.5-13.5-6.8c-2.9-4.1-3.2-9.5-0.8-12    c2-2,5.2-1.7,8.8,0.7c3.2,2.2,7.7,2.2,10.9,0c5.1-3.4,7.8-1.6,8.8-0.6C50.1,31.4,49.8,36.6,46.8,40.8z"></path>
                    <path
                        d="M40.4,29.6c0.3,0.6,0.8,1.7,0.7,2.1c-0.2,0.7-1.5,2.3-3,1.6c-0.4-0.2-0.7-1.4-0.8-2c-0.1,0-0.3,0.1-0.4,0.1    c0.3,0.6,0.7,1.7,0.5,2.1c-0.5,1-2.5,1.3-3.4,0.6c-0.4-0.3-0.4-1.5-0.4-2.2c-0.4,0-0.8,0-1.3-0.1c0.1,0.7,0.3,1.9-0.1,2.2    c-0.7,0.7-2.4,0.3-2.9-0.6c-0.2-0.4,0.1-1.6,0.3-2.2c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0.7-0.2,1.9-0.6,2.1c-1.5,0.8-2.7-0.9-3-1.6    c-0.2-0.4,0.2-1.6,0.5-2.2c-1.4-0.8-2.7-1.2-3.8-1.2c-1,0-1.9,0.3-2.6,1c-1.9,1.9-2.1,6.6,0.9,10.8c1.2,1.7,2.9,3.2,4.7,4.2    c0.1-0.7,0.2-1.9,0.7-2.1c1-0.4,2.5,0.4,3,1.4c0.2,0.4-0.2,1.5-0.4,2.1c0.2,0.1,0.3,0.1,0.5,0.2c0-0.7,0.1-1.9,0.5-2.1    c0.7-0.5,2-0.2,2.6,0.5c0.3,0.3,0.2,1.5,0.1,2.2c0.4,0,0.7,0.1,1.1,0.1c0,0,0,0,0,0c0.2,0,0.3,0,0.5,0c-0.2-0.7-0.5-1.8-0.2-2.1    c0.7-0.8,2.3-1,3.2-0.4c0.4,0.2,0.6,1.4,0.7,2.1c0.2,0,0.4-0.1,0.6-0.2c-0.3-0.6-0.8-1.6-0.6-2.1c0.5-1,2-1.7,3.1-1.4    c0.4,0.2,0.7,1.3,0.8,2c1.8-1.1,3.4-2.4,4.6-4.2c2.9-4.1,2.7-8.8,0.8-10.7C45.4,28,43.1,28.1,40.4,29.6z"></path></g></g>
            </svg>
      <h2>幻音阁</h2>
    </div>
    <!-- 主菜单 -->
    <div class="header-menu" :class="{'header-menu-change-search':isChangeSearch}">
      <router-link active-class="active" to="/treasure">百宝箱</router-link>
<!--      <router-link active-class="active" to="/record">记录线</router-link>-->
<!--      <router-link active-class="active" to="/shortcut">喜捷径</router-link>-->
    </div>
    <!-- 搜索框 -->
    <!--		<div class="search-bar" :class="{'search-bar-change-search': isChangeSearch}">-->
    <!--			<input type="text" @focusin="changeStyle" @focusout="changeStyle" placeholder="请输入关键字">-->
    <!--			-->
    <!--		</div>-->
    <!-- 头像区域 -->
    <div class="header-profile">
      <el-tooltip :content="'专属服务: ' + dailiContent" placement="top" >
      <el-text class="mx-2" @click="showActiveDialog"
               style="color: white;font-size: 15px;display: flex;align-items: center;justify-content: center;">✨至尊会员{{CaculateCodeLevelText}}:{{CaculateExpireTime}}
      </el-text>
      </el-tooltip>
      <span> </span>
      <el-tooltip content="邀请1个好友使用免费周卡+1，不设上限！" placement="top" >
        <el-text class="mx-2 copy-btn" @click="generateInviterCode" :data-clipboard-text="InviterCode"
                 style="color: white;font-size: 15px;display: flex;align-items: center;justify-content: center;">🌈邀请码:{{InviterCode}}{{InviterCode.length === 6 ? '[复制]' : ''}}
        </el-text>
      </el-tooltip>

      <div class="notification" style="margin: 0 15px;" @click="showInfo">
        <span class="notification-number" v-if="unreadNum > 0">{{ unreadNum }}</span>
        <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-029747aa="">
          <path fill="currentColor"
                d="M384 960v-64h192.064v64H384zm448-544a350.656 350.656 0 0 1-128.32 271.424C665.344 719.04 640 763.776 640 813.504V832H320v-14.336c0-48-19.392-95.36-57.216-124.992a351.552 351.552 0 0 1-128.448-344.256c25.344-136.448 133.888-248.128 269.76-276.48A352.384 352.384 0 0 1 832 416zm-544 32c0-132.288 75.904-224 192-224v-64c-154.432 0-256 122.752-256 288h64z"></path>
        </svg>
      </div>

      <div style="margin: 0 20px;" @click="actionSettings">
        <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-029747aa="">
          <path fill="currentColor"
                d="M764.416 254.72a351.68 351.68 0 0 1 86.336 149.184H960v192.064H850.752a351.68 351.68 0 0 1-86.336 149.312l54.72 94.72-166.272 96-54.592-94.72a352.64 352.64 0 0 1-172.48 0L371.136 936l-166.272-96 54.72-94.72a351.68 351.68 0 0 1-86.336-149.312H64v-192h109.248a351.68 351.68 0 0 1 86.336-149.312L204.8 160l166.208-96h.192l54.656 94.592a352.64 352.64 0 0 1 172.48 0L652.8 64h.128L819.2 160l-54.72 94.72zM704 499.968a192 192 0 1 0-384 0 192 192 0 0 0 384 0z"></path>
        </svg>
      </div>
      <img class="profile-img" :src="avatarUrl" alt="">
    </div>
  </div>

  <el-dialog class="222" v-model="dialogFormVisible" @closed="lookedInfo()" title="消息列表"
             style="background: -webkit-linear-gradient(left,  rgb(145, 217, 246) 0%,#db6ff3 100%);">
    <ul v-if="globalMessage.length > 0" v-infinite-scroll="localMore" class="infinite-list" style="overflow: auto">
      <li v-for="(message, index) in globalMessage" :key="message.id" class="infinite-list-item"
          :style="index === expendLi ? 'height: auto;' : ''" @click="toggleHeight(index)" ref="liItem">
        <transition name="fade" mode="out-in">
          <div class="message-details"
               style="display: flex;flex-direction: column;width: 100%;margin: 10px;height: auto;">
            <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: flex-start;">
              <h3>{{ message.title }}</h3>
              <p>{{ message.time }}</p>
            </div>
            <div v-if="index === expendLi" class="message-content-full">{{ message.content }}</div>
          </div>
        </transition>
      </li>
    </ul>
    <el-text v-else class="mx-1"
             style="color: white;font-size: 30px;display: flex;align-items: center;justify-content: center;">消息为空~~
    </el-text>
    <br/>
    <template v-if="globalMessage.length > 0" #footer>
      <button class="custom-btn btn-9" @click="clearMessage"><span>清空</span></button>
    </template>
  </el-dialog>

<!--  <div class="btn-1">-->
<!--    <el-dialog class="dialog-content" v-model="dialogSettingsVisible" @closed="closeSettings()" title="设置"-->
<!--               style="background: -webkit-linear-gradient(left,  rgb(145, 217, 246) 0%,#db6ff3 100%);">-->
<!--      <button class="custom-btn btn-9 center-button" @click="refreshRules"><span>更新扣排规则</span></button>-->
<!--    </el-dialog>-->
<!--  </div>-->

  <el-dialog class="111" v-model="headerExpireDialog" @close="closeActiveDialog" title="激活密钥" style="background: -webkit-linear-gradient(left,  rgb(145, 217, 246) 0%,#db6ff3 100%);">
    <el-form  class="center-button">
      <el-form-item >
        <el-text class="mx-1" style="color: white;font-size: 20px;">请输入密钥</el-text><br/>
      </el-form-item>
      <el-form-item >
        <el-input class="dynamic-width-input" v-model="secret" placeholder="请输入密钥"
                  clearable style="width: 100%;"/>
      </el-form-item>
      <el-form-item >
        <el-text class="mx-1" style="color: white;font-size: 20px;">如有疑问，请联系技术支持 {{dailiContent}}</el-text>
      </el-form-item>
      <el-form-item >
        <button class="custom-btn btn-9 center-button" @click="handleActive"><span>激 活</span></button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import axios from "axios";
import Clipboard from 'clipboard';
import {ElMessage} from "element-plus";
import {handleEncryptData} from "@/libs/tools";
import {isDebug} from "@/config/config";

export default {
  data() {
    return {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      isChangeSearch: false,
      dialogFormVisible: false,
      dialogSettingsVisible: false,
      baseUrl: "http://127.0.0.1:5000",
      formLabelWidth: "88px",
      settingsJson: {
        account: "",
        password: ""
      },
      getInfoInterval: null,
      count: 0,
      expendLi: -1,
      isExpired: false,
      dialogActiveVisible: false,
      messages: [
        {id: 1, title: '消息标题1', time: '2024-02-02 10:00', content: '消息内容1...'},
        {id: 2, title: '消息标题2', time: '2024-02-02 11:30', content: '消息内容2...'},
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initCopyBoard();
      this.checkIsExpired();
      this.getInfoInterval = setTimeout(() => {
        this.generateInviterCode()
        this.getDailiInfo()
      }, 5000)
    });
  },
  methods: {
    initCopyBoard() {
      // console.log(this.$refs.copyBtn)
      const clipboard = new Clipboard('.copy-btn');

      clipboard.on('success', () => {
        ElMessage.success('复制成功');
      });

      clipboard.on('error', () => {
        ElMessage.error('复制失败');
      });
    },
    async refreshRules() {
      let url = this.baseUrl + "/load_new_fun"
      let data = {}
      let resData = await this.postAxios(url, data)
      if(resData === {}) {
        ElMessage.success("刷新成功")
      }
    },
    async generateInviterCode() {
      if(this.$store.state.InviterCode.length === 6) {
        return
      }
      if(!this.$store.state.secret) {
        this.$store.state.InviterCode = "点击生成"
        // ElMessage.error("点击生成")
      } else {
        let url = this.$store.state.baseRemoteUrl + "/v1/inviter_code/create_or_get"
        let data = {
          "code": this.$store.state.secret,
          "code_type": "KouPaiQi"
        }
        let resData = await this.postAxios(url, data)
        // console.log(resData)
        if(resData.code === 0) {
          this.$store.commit("setInviterCode", resData.data.inviter_code)
          ElMessage.success("获取成功: " + resData.data.inviter_code)
        } else {
          ElMessage.error("获取失败")
        }
      }

    },
    async getDailiInfo() {
      if(!this.$store.state.secret) {
        this.$store.state.DailiInfo = {}
      } else {
        let url = this.$store.state.baseRemoteUrl + "/v1/daili_info/find_by_code"
        let data = {
          "code": this.$store.state.secret
        }
        let resData = await this.postAxios(url, data)
        // console.log(resData)
        if(resData.code === 0) {
          this.$store.commit("setDailiInfo", resData.data)
        }
      }

    },
    showActiveDialog() {
      this.$store.commit('setHeaderExpireDialog', true);
      this.$store.commit('setSecret', "");
    },
    async handleActive() {
      // let url = this.baseUrl + "/action"
      // 111console.log("激活1")
      let data = {
        "type": "ACTIVE_CODE",
        "data": {
          "code": this.secret
        },
        "data_type": "action"
      }
      // let resData = await this.postAxios(url, data)
      if (this.$store.state.websocket) {
        this.$store.state.websocket.emit('message', handleEncryptData(data, isDebug));
      } else {
        console.error('WebSocket not connected!');
      }
      // let resData = await this.postAxios(url, data)
      // if(resData) {
      //   this.$store.commit('setExpireTime', resData["data"]["expire_time"]);
      //   this.dialogFormVisible = false
      //   this.secret = ""
      // }

    },
    async postAxios(url, data) {
      try {
        let res = await axios.post(url, data)
        if(res.status === 200) {
          // 111console.log(res["data"])
          if(res["data"].code === 0) {
            return res["data"]
          } else {
            ElMessage.warning(res["data"].msg)
          }
        }
      } catch (e) {
        ElMessage.warning("网络异常!")
      }
    },
    closeActiveDialog() {
      this.dialogActiveVisible = false
      this.secret = ""
    },
    checkIsExpired() {
      if(this.getRemainingTime(this.$store.state.expireTime) === "启动未成功") {
        this.$store.commit("setIsExpired", true)
      } else {
        this.$store.commit("setIsExpired", false)
      }
    },
    actionSettings() {
      this.dialogSettingsVisible = true

    },
    closeSettings() {
      this.dialogSettingsVisible = false
    },
    saveSettings() {
      // 111console.log(this.settingsJson)
      this.dialogSettingsVisible = false
    },
    toggleHeight(i) {
      if (i === this.expendLi) {
        this.expendLi = -1
      } else {
        this.expendLi = i
      }
    },
    clearMessage() {
      this.$store.state.unreadNum = 0
      this.$store.state.globalMessage = []
    },
    localMore() {
      this.count += 2
    },
    showInfo() {
      this.dialogFormVisible = true
      this.expendLi = -1
    },
    lookedInfo() {
      this.$store.state.unreadNum = 0
      let liItem = this.$refs.liItem;
      if (this.expendLi !== -1) {
        if (liItem && liItem.length > 0) {
          if(liItem[this.expendLi - 1]) {
            liItem[this.expendLi - 1].classList.remove('expanded');
          }
        }
      }
      this.expendLi = -1
    },
    changeStyle() {
      this.isChangeSearch = !this.isChangeSearch
      // 111console.log('聚焦')
    },
    getRemainingTime(targetTimeStr) {
      if(targetTimeStr === "启动未成功") {
        return "启动未成功";
      }
      const targetTime = new Date(targetTimeStr);
      const currentTime = new Date();

      const timeDifference = targetTime - currentTime; // 时间差，单位为毫秒

      if (timeDifference <= 0) {
        return "启动未成功";
      }

      const millisecondsInMinute = 60 * 1000;
      const millisecondsInHour = 60 * millisecondsInMinute;
      const millisecondsInDay = 24 * millisecondsInHour;

      if (timeDifference >= millisecondsInDay) {
        const daysRemaining = Math.floor(timeDifference / millisecondsInDay);
        let remindSeconds = timeDifference - (daysRemaining * millisecondsInDay)
        let hoursRemaining = Math.floor(remindSeconds / millisecondsInHour);
        return `剩余 ${daysRemaining} 天 ${hoursRemaining} 小时`;
      } else if (timeDifference >= millisecondsInHour) {
        const hoursRemaining = Math.floor(timeDifference / millisecondsInHour);
        return `剩余 ${hoursRemaining} 小时`;
      } else {
        const minutesRemaining = Math.floor(timeDifference / millisecondsInMinute);
        return `剩余 ${minutesRemaining} 分钟`;
      }
    },
    getCodeLevelText(CodeLevel) {
      if(CodeLevel >= 9) {
        return "Pro";
      }
      return ""
    }
  },
  computed: {
    headerExpireDialog: {
      get() {
        return this.$store.state.headerExpireDialog;
      },
      set(value) {
        // 使用 Vuex mutation 来更新状态
        this.$store.commit('setHeaderExpireDialog', value);
      }
    },
    secret: {
      get() {
        return this.$store.state.secret;
      },
      set(value) {
        // 使用 Vuex mutation 来更新状态
        this.$store.commit('setSecret', value);
      }
    },
    avatarUrl() {
      return this.$store.state.avatarUrl;
    },
    DailiInfo() {
      return this.$store.state.DailiInfo
    },
    dailiContent() {
      if(Object.prototype.hasOwnProperty.call(this.$store.state.DailiInfo, "daili_content")) {
        return this.$store.state.DailiInfo["daili_content"]
      }
      return ""
    },
    CaculateExpireTime() {
      return this.getRemainingTime(this.$store.state.expireTime)
    },
    CaculateCodeLevelText() {
      return this.getCodeLevelText(this.$store.state.CodeLevel)
    },
    InviterCode() {
      return this.$store.state.InviterCode
    },
    globalMessage() {
      return this.$store.state.globalMessage;
    },
    unreadNum() {
      return this.$store.state.unreadNum;
    },
  },

}
</script>

<style lang="scss" scoped>

 .custom-btn {
  width: 130px;
  height: 40px;
  color: #fff;
  border-radius: 5px;
  padding: 10px 10px;
  //margin: 0 10px;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
  box-shadow:inset 2px 2px 2px 0px rgba(255,255,255,.5), 7px 7px 20px 0px rgba(0,0,0,.1),
  4px 4px 5px 0px rgba(0,0,0,.1);
  outline: none;

}

.btn-9 {
  border: none;
  transition: all 0.3s ease;
  overflow: hidden;

  &:after {
    position: absolute;
    content: " ";
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #1fd1f9;
    background-image: linear-gradient(315deg, #1fd1f9 0%, #b621fe 74%);
    transition: all 0.3s ease;
  }
  &:hover {
    background: transparent;
    box-shadow:  4px 4px 6px 0 rgba(255,255,255,.5),
    -4px -4px 6px 0 rgba(116, 125, 136, .2),
    inset -4px -4px 6px 0 rgba(255,255,255,.5),
    inset 4px 4px 6px 0 rgba(116, 125, 136, .3);
    color: #fff;
  }
  &:hover:after {
    -webkit-transform: scale(2) rotate(180deg);
    transform: scale(2) rotate(180deg);
    box-shadow:  4px 4px 6px 0 rgba(255,255,255,.5),
    -4px -4px 6px 0 rgba(116, 125, 136, .2),
    inset -4px -4px 6px 0 rgba(255,255,255,.5),
    inset 4px 4px 6px 0 rgba(116, 125, 136, .3);
  }
}

.dynamic-width-input {
  width: 200px; /* 设置默认较短的宽度 */
  min-width: 100px; /* 设置最小宽度 */
  max-width: 500px; /* 设置最大宽度 */
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active 在 <2.1.8 版本中可用 */
, .fade-enter-active, .fade-leave {
  opacity: 0;
}

.infinite-list {
  height: 300px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.infinite-list .infinite-list-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  background: var(--el-color-primary-light-9);
  margin: 10px;
  color: var(--el-color-primary);
  border-radius: 10px;
  // 添加过渡效果
  transition: height 0.3s ease;
}

.infinite-list .infinite-list-item:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2); /* 增加阴影效果 */
}

.infinite-list .infinite-list-item + .list-item {
  margin-top: 5px;
}

// 增加高度的状态
.infinite-list .infinite-list-item.expanded {
  height: auto; // 你可以根据需要设置增加的高度
}

.header {
   //background-color: skyblue;
  background: -webkit-linear-gradient(left, rgb(145, 217, 246) 0%, #db6ff3 100%);
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 58px;
  width: 100%;
  border-bottom: 1px solid rgba(113 119 144 / 25%);
  padding: 0 30px;
  white-space: nowrap;
  @media screen and (max-width: 480px) {
    padding: 0 16px;
  }

  .logo {
    width: 96px;
    height: 30px;
    margin-right: 110px;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;

    @media screen and (max-width: 945px) {
      display: none;
    }

    h2 {
      background-image: linear-gradient(#dc81f1, #db6ff3);
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
    }

    svg {
      //fill:currentColor;
      fill: #db6ff3;
    }

  }

  /* .head-menu */
  &-menu {
    display: flex;
    align-items: center;

    a {
      padding: 20px 30px;
      text-decoration: none;
      color: rgb(60, 62, 70);
      border-bottom: 2px solid transparent;
      transition: 0.3s;
      @media screen and (max-width: 610px) {
        &:not(.main-header-link) {
          display: none;
        }
      }

    }

    a:hover,
    a.active {
      color: #ffffff;
      border-bottom: 2px solid #ffffff;
    }

  }

  .notify {
    position: relative;

    &:before {
      content: "";
      position: absolute;
      background-color: #3a6df0;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      right: 20px;
      top: 16px;
    }

    @media screen and (max-width: 1055px) {
      display: none;
    }
  }

  .search-bar {
    height: 40px;
    display: flex;
    width: 100%;
    max-width: 400px;
    padding-left: 16px;
    border-radius: 4px;
    border: none;

    input {
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      background-color: #b7bbea;
      background-color: white;
      border-radius: 4px;
      font-family: "Poppins", sans-serif;
      font-size: 15px;
      font-weight: 500;
      padding: 0 20px 0 40px;
      //box-shadow: 0 0 0 2px rgb(134 140 160 / 0%);
      background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56.966 56.966' fill='%23717790c7'%3e%3cpath d='M55.146 51.887L41.588 37.786A22.926 22.926 0 0046.984 23c0-12.682-10.318-23-23-23s-23 10.318-23 23 10.318 23 23 23c4.761 0 9.298-1.436 13.177-4.162l13.661 14.208c.571.593 1.339.92 2.162.92.779 0 1.518-.297 2.079-.837a3.004 3.004 0 00.083-4.242zM23.984 6c9.374 0 17 7.626 17 17s-7.626 17-17 17-17-7.626-17-17 7.626-17 17-17z'/%3e%3c/svg%3e");
      background-size: 14px;
      background-repeat: no-repeat;
      background-position: 16px 48%;
      //color: #212324;
      &::placeholder {
        font-family: "Poppins", sans-serif;
        color: rgb(131, 131, 237);
        font-size: 15px;
        font-weight: 500;
      }
    }

    input:focus {
      border: 2px solid rgb(192, 134, 192);
    }

  }

  .header-profile {
    display: flex;
    align-items: center;
    //text-align: center;
    padding: 0 16px 0 40px;
    margin-left: auto;
    flex-shrink: 0;

    .icon-container {
      display: flex;
      align-items: center;
      justify-content: space-around;

      .custom-btn {
        width: 130px;
        height: 40px;
        color: #fff;
        border-radius: 5px;
        padding: 10px 10px;
        //margin: 0 10px;
        font-family: 'Lato', sans-serif;
        font-weight: 500;
        background: transparent;
        cursor: pointer;
        transition: all 0.3s ease;
        position: relative;
        display: inline-block;
        box-shadow:inset 2px 2px 2px 0px rgba(255,255,255,.5), 7px 7px 20px 0px rgba(0,0,0,.1),
        4px 4px 5px 0px rgba(0,0,0,.1);
        outline: none;
      }

      .btn-9 {
        border: none;
        transition: all 0.3s ease;
        overflow: hidden;

        &:after {
          position: absolute;
          content: " ";
          z-index: -1;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #1fd1f9;
          background-image: linear-gradient(315deg, #1fd1f9 0%, #b621fe 74%);
          transition: all 0.3s ease;
        }
        &:hover {
          background: transparent;
          box-shadow:  4px 4px 6px 0 rgba(255,255,255,.5),
          -4px -4px 6px 0 rgba(116, 125, 136, .2),
          inset -4px -4px 6px 0 rgba(255,255,255,.5),
          inset 4px 4px 6px 0 rgba(116, 125, 136, .3);
          color: #fff;
        }
        &:hover:after {
          -webkit-transform: scale(2) rotate(180deg);
          transform: scale(2) rotate(180deg);
          box-shadow:  4px 4px 6px 0 rgba(255,255,255,.5),
          -4px -4px 6px 0 rgba(116, 125, 136, .2),
          inset -4px -4px 6px 0 rgba(255,255,255,.5),
          inset 4px 4px 6px 0 rgba(116, 125, 136, .3);
        }
      }
    }


    svg {
      width: 22px;
      color: #f9fafb;
      flex-shrink: 0;
    }

    .notification {
      position: relative;
      top: 2px;

      &-number {
        position: absolute;
        background-color: #3a6df0;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        font-size: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        right: -6px;
        top: -6px;
      }

      & + svg {
        margin-left: 22px;
        @media screen and (max-width: 945px) {
          display: none;
        }
      }
    }

    .profile-img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      object-fit: cover;
      border: 2px solid #f9fafb;
      margin-left: 22px;
    }
  }

  /*输入框聚焦后，样式改变 */

  .header-menu-change-search {
    display: none;
  }

  .search-bar-change-search {
    max-width: 600px;
    margin: auto;
    transition: 0.4s;
    box-shadow: 0 0 0 1px rgba(113 119 144 / 25%);
    padding-left: 0;
  }


  .change-search {
    .header-menu,
    .header-profile {
      display: none;
    }

    .search-bar {
      max-width: 600px;
      margin: auto;
      transition: 0.4s;
      box-shadow: 0 0 0 1px rgba(113 119 144 / 25%);
      padding-left: 0;
    }

    .logo {
      margin-right: 0;
    }
  }
}


</style>
